import styled from '@emotion/styled'
import { css } from '@emotion/react'

const ratingStarsStyles = ({ theme }) => css`
  label: product__rating-stars;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  height: 28px;

  .bv_text {
    color: ${theme.colors.g300} !important;
  }

  .bv-widget-rating {
    font-size: ${theme.typography.text.kilo};
  }

  .bv_main_container {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .bv_stars_component_container {
      margin-right: ${theme.spacings.byte};
    }
  }
`

export const RatingStars = styled('div')(ratingStarsStyles)
